// @ts-strict-ignore
import { Size } from 'src/components/avatar';
import Badge from 'src/components/badge';
import { Element, Section } from 'src/constants/footfall';
import { SupportingMemberEl, SupportingMemberAvatar, SupportingMemberUser, SupportingMemberLink } from 'src/modules/community/communityAbout/components/sharedStyles';
import UserLink from 'src/modules/shared/links/userLink';

export function UserCard({ username, userImageHash, role }): JSX.Element {
  return (
    <SupportingMemberEl>
      <SupportingMemberAvatar>
        <UserLink
          avatarSize={Size.Small}
          signupContext={{
            element: Element.AVATAR,
            section: Section.CommunityAbout,
          }}
          user={{
            username,
            userImageHash,
          }}
        />
      </SupportingMemberAvatar>
      <SupportingMemberUser>
        <SupportingMemberLink
          signupContext={{
            element: Element.USER_LINK,
            section: Section.CommunityAbout,
          }}
          user={{ username }}
        />
        <Badge key="user-link-badge">{role}</Badge>
      </SupportingMemberUser>
    </SupportingMemberEl>
  );
}
